<template>
  <div class="about">
    <page-header :title="$t('club.edit')" :desc="model.name">
      <li class="breadcrumb-item"><router-link :to="{name:'clubs.index'}">{{$tc('club.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{model.name}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block :title="$tc('image.name', 1)" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">1:1</span>, {{ $t('size') }}: <span class="font-weight-bold">500x500</span></span>
          </template>
          <ntm-crop entity-type="club" :entity-uuid="$route.params.uuid" conversion="lg" collection="logo" :circle="true"></ntm-crop>
        </ntm-block>
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15" data-testid="club-save">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import ClubService from '@/services/club.service'
import clubShortNameMixin from '@/mixins/club.short-name.mixin'
import router from '@/router'

export default {
  mixins: [clubShortNameMixin],
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields,
      uploading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    ClubService.show(to.params.uuid).then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  // beforeRouteUpdate (to, from, next) {
  //   ClubService.show(to.params.uuid).then((response) => {
  //     this.setData(response.data)
  //     store.commit('loaded')
  //   })
  // },
  methods: {
    setData (data) {
      this.model = data
    },
    onSubmit () {
      ClubService.update(this.model.uuid, this.model).then((response) => {
        router.push({ name: 'clubs.index' })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
